/**
 * Timeline Options Composable
 *
 * Handles the option selection modal state and flow
 */
import { ref, reactive } from '@vue/composition-api';

/**
 * Composable for timeline option selection
 * @returns {Object} Modal state and methods
 */
export function useTimelineOptions() {
  // Modal state
  const isCardModalActive = ref(false);

  // Current timeline being answered
  const currentTimeline = reactive({
    id: null,
    eventTime: '',
    report: '',
    result: '',
    answer: '',
    options: []
  });

  /**
   * Open the options modal for a timeline
   * @param {Object} timeline - Timeline to answer
   */
  const openOptions = (timeline) => {
    Object.assign(currentTimeline, {
      id: timeline.id,
      eventTime: timeline.eventTime,
      report: timeline.report,
      result: timeline.result,
      answer: timeline.answer,
      options: timeline.options
    });
    isCardModalActive.value = true;
  };

  /**
   * Close the options modal
   */
  const hideOptions = () => {
    isCardModalActive.value = false;
  };

  /**
   * Check if selected option is correct
   * @param {string} option - Selected option
   * @returns {boolean} Whether the option is correct
   */
  const isCorrectOption = (option) => {
    return option === currentTimeline.answer;
  };

  return {
    // State
    isCardModalActive,
    currentTimeline,

    // Methods
    openOptions,
    hideOptions,
    isCorrectOption
  };
}
